import { BookPill } from "./BookPill";
import { Reveal } from "./Reveal";
import { Doodles } from "./Doodles";
import { EMAIL } from "../constants/site";
import "./FinalCta.css";

const LINE_COUNT = 20;

export const FinalCta = () => {
    return (
        <section className="final-cta" id="book" data-testid="final-cta-section">
            <div className="cta-lines cta-lines-left" aria-hidden="true">
                {Array.from({ length: LINE_COUNT }).map((_, i) => (
                    <span
                        key={`l-${i}`}
                        className="cta-line"
                        style={{
                            width: `${60 + i * 10}px`,
                            animationDelay: `${i * 0.25}s`,
                        }}
                    />
                ))}
            </div>
            <div className="cta-lines cta-lines-right" aria-hidden="true">
                {Array.from({ length: LINE_COUNT }).map((_, i) => (
                    <span
                        key={`r-${i}`}
                        className="cta-line"
                        style={{
                            width: `${60 + i * 10}px`,
                            animationDelay: `${i * 0.25}s`,
                        }}
                    />
                ))}
            </div>
            <div className="cta-lines cta-lines-top" aria-hidden="true">
                {Array.from({ length: LINE_COUNT }).map((_, i) => (
                    <span
                        key={`t-${i}`}
                        className="cta-line"
                        style={{
                            height: `${60 + i * 10}px`,
                            animationDelay: `${i * 0.25}s`,
                        }}
                    />
                ))}
            </div>

            <Doodles
                items={[
                    {
                        type: "sparkle",
                        color: "green",
                        size: 26,
                        style: { top: "22%", left: "14%" },
                    },
                    {
                        type: "plus",
                        color: "pink",
                        size: 20,
                        style: { top: "30%", right: "16%" },
                        delay: "0.8s",
                    },
                    {
                        type: "ring",
                        color: "blue",
                        size: 24,
                        style: { bottom: "20%", left: "20%" },
                        delay: "1.4s",
                    },
                ]}
            />

            <div className="final-cta-content">
                <Reveal
                    as="h2"
                    className="final-cta-heading"
                    data-testid="final-cta-heading"
                >
                    Your next upload could be the one that{" "}
                    <span className="serif">changes</span> the channel.
                </Reveal>
                <Reveal
                    as="p"
                    className="final-cta-intro"
                    delay={0.1}
                    data-testid="final-cta-intro"
                >
                    Book a call. If we are not the right fit we will tell you
                    who is.
                </Reveal>
                <Reveal className="final-cta-row" delay={0.2}>
                    <BookPill testid="final-cta-book-pill" />
                    <a
                        className="final-cta-email"
                        href={`mailto:${EMAIL}`}
                        data-testid="final-cta-email-link"
                    >
                        or email {EMAIL}
                    </a>
                </Reveal>
            </div>
        </section>
    );
};
